import { Box, Flex, FloraButton, Heading } from '@grupoboticario/flora-react'
import { slugify } from '@grupoboticario/tag-book-sellout'
import { useMemo } from 'react'
import { useSlidesToShow } from 'src/hooks'
import { trackShopWindowEvents } from 'src/service/trackShopWindowEvents'
import { CarouselShop } from './CarouselShop'
import { LoadingSkeleton } from './LoadingSkeleton'
import { ShopWindowItemProps } from './types'

export const ShopWindowItem = ({
  title,
  products,
  cycle,
  shopWindowType,
  shopWidth,
  isMobile,
  isLoading,
  seeAllLink,
  banners,
  slidesToShow: slidesToShowFromProps,
}: ShopWindowItemProps) => {
  const slidesToShowDefault = useSlidesToShow()

  const handleNavigate = () => {
    if (!seeAllLink) return

    trackShopWindowEvents({
      cd_interaction_detail: `click:ver-tudo:${slugify(shopWindowType)}`,
      listName: shopWindowType,
      cycle,
    })

    if (seeAllLink.type === 'external') {
      window.open(seeAllLink.url, '_blank', 'noopener noreferrer')
      return
    }

    if (seeAllLink.type === 'internal') {
      window.location.href = seeAllLink.url
    }
  }

  const banner = useMemo(() => {
    if (isMobile && banners?.mobile) {
      return banners.mobile
    }

    if (!isMobile && banners?.desktop) {
      return banners.desktop
    }

    return null
  }, [isMobile, banners])

  return (
    <Box css={{ margin: '$4 0' }}>
      <Flex
        align="center"
        justify="space-between"
        css={{ marginBottom: '$3' }}
      >
        <Heading
          level="6"
          color="$nonInteractivePredominant"
          id="carousel-heading"
        >
          {title}
        </Heading>
        {seeAllLink ? (
          <FloraButton
            hierarchy="secondary"
            size="small"
            onClick={handleNavigate}
          >
            Ver tudo
          </FloraButton>
        ) : null}
      </Flex>
      {banner ? (
        <Box
          css={{
            margin: '0 -$4 $4',
            width: '100vw',
            height: 'auto',
            '@desktop': {
              margin: '0 0 $4',
              width: '100%',
            },
          }}
        >
          <img
            loading="lazy"
            src={banner.url}
            aria-hidden={banner.alt ? 'false' : 'true'}
            alt={banner.alt ?? ''}
            style={{ objectFit: 'contain', height: '100%', width: '100%' }}
          />
        </Box>
      ) : null}
      {isLoading ? (
        <LoadingSkeleton />
      ) : (
        <Box
          css={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <CarouselShop
            isMobile={isMobile}
            shopWindowType={shopWindowType}
            products={products ?? []}
            shopWidth={shopWidth}
            slidesToShow={slidesToShowFromProps || slidesToShowDefault}
            cycle={cycle}
          />
        </Box>
      )}
    </Box>
  )
}
